import {
  IconBilling,
  IconDashboard,
  IconDescription,
  IconFavorite,
  IconProfile,
} from "@origin-digital/ods-icons";
import { BaseSvgIconProps } from "@origin-digital/ods-icons/dist/typings/SvgIcon/SvgIcon";
import { SvgIconColorVariants } from "@origin-digital/ods-types";
import React from "react";

export const icons = {
  IconDashboard: <IconDashboard />,
  IconBilling: <IconBilling />,
  IconDescription: <IconDescription />,
  IconFavorite: <IconFavorite />,
  IconProfile: <IconProfile />,
};

interface IconProps {
  name?: string;
  color?: SvgIconColorVariants;
  variant?: BaseSvgIconProps["variant"];
}

export const Icon: React.FC<IconProps> = ({ name, color, variant }) => {
  if (name) {
    return React.cloneElement(
      icons[name as keyof typeof icons] || (
        <IconDashboard color={color} variant={variant} />
      ),
      { color, variant }
    );
  } else {
    return null;
  }
};
